// Mirrors App\Support\Bootstrap\BootstrapService (W4 D2). Hand-written for now;
// graduates to a generated @marine/contracts type in W3-FU.
export interface BootstrapTenant {
  id: string;
  name: string;
  subdomain: string;
  logoUrl: string | null;
  brandColor: string | null;
}

export interface BootstrapData {
  schemaVersion: number;
  env: { appEnv: string; release: string };
  csrfToken: string;
  tenant: BootstrapTenant | null;
  modules: string[];
  auth: { employee: Record<string, unknown>; preferences: Record<string, unknown> } | null;
}

export const BOOTSTRAP_SCHEMA_VERSION = 1;
